import { useMutation } from "@tanstack/react-query";
import { CustomizationWelcome } from "@graylog/enterprise-api";
const useUpdateWelcomePageConfiguration = () => useMutation({
  mutationFn: (config) => CustomizationWelcome.update(config.news_section, config.release_section)
});
export default useUpdateWelcomePageConfiguration;
